import React from 'react';
import {
  getSubCategoryId, installment_options_alignment_key, installment_options_column_key,
  installmentOptionsList,
} from '../utils/DictionaryManagementUtils';
import SimulatorsViewerArrangement
  from '../components/SimulatorsComponents/FullPagesComponents/SimulatorsViewerArrangement';
import SelectOperatorFP
  from '../components/SimulatorsComponents/FullPagesComponents/Services/Operator/SelectOperatorFP';

const Sim_J04_LoanInstallmentOptions = ({
  globJSON,
  selectedScreen,
  simPlatform,
  slideshowRefs,
}) => {
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const { option } = globJSON.configurations.services[subCategoryId];
  const numberColumns = option.multiple_columns === installment_options_column_key.column_1 ? 1 : 2;
  const contentAlignment = option.content_aligned_center === installment_options_alignment_key.center;

  return (
    <SimulatorsViewerArrangement>
      <SelectOperatorFP
        globJSON={globJSON}
        simPlatform={simPlatform}
        headlineText={option.select_loan_option}
        operatorsList={installmentOptionsList}
        numberColumns={numberColumns}
        enableScreen
        slideshowRefs={slideshowRefs}
        contentAlignedCenter={contentAlignment}
      />
    </SimulatorsViewerArrangement>
  );
};

export default Sim_J04_LoanInstallmentOptions;
